import React from 'react';
import { useNavigate } from 'react-router-dom';
import styles from './MapNavigation.module.css';
import { MapData } from '../utils/types';
import { Button } from 'react-bootstrap';

const mapColorClasses: { [key: string]: string } = {
  ABYSS: styles.mapButtonAbyss,
  ASCENT: styles.mapButtonAscent,
  BIND: styles.mapButtonBind,
  BREEZE: styles.mapButtonBreeze,
  HAVEN: styles.mapButtonHaven,
  SPLIT: styles.mapButtonSplit,
  PEARL: styles.mapButtonPearl,
  LOTUS: styles.mapButtonLotus,
  SUNSET: styles.mapButtonSunset,
  ICEBOX: styles.mapButtonIcebox,
  FRACTURE: styles.mapButtonFracture,
  CORRODE: styles.mapButtonCorrode,
};

const mapActiveColorClasses: { [key: string]: string } = {
  ABYSS: styles.mapButtonAbyssActive,
  ASCENT: styles.mapButtonAscentActive,
  BIND: styles.mapButtonBindActive,
  BREEZE: styles.mapButtonBreezeActive,
  HAVEN: styles.mapButtonHavenActive,
  SPLIT: styles.mapButtonSplitActive,
  PEARL: styles.mapButtonPearlActive,
  LOTUS: styles.mapButtonLotusActive,
  SUNSET: styles.mapButtonSunsetActive,
  ICEBOX: styles.mapButtonIceboxActive,
  FRACTURE: styles.mapButtonFractureActive,
  CORRODE: styles.mapButtonCorrodeActive,
};

const mapDisabledColorClasses: { [key: string]: string } = {
  ABYSS: styles.mapButtonAbyssDisabled,
  ASCENT: styles.mapButtonAscentDisabled,
  BIND: styles.mapButtonBindDisabled,
  BREEZE: styles.mapButtonBreezeDisabled,
  HAVEN: styles.mapButtonHavenDisabled,
  SPLIT: styles.mapButtonSplitDisabled,
  PEARL: styles.mapButtonPearlDisabled,
  LOTUS: styles.mapButtonLotusDisabled,
  SUNSET: styles.mapButtonSunsetDisabled,
  ICEBOX: styles.mapButtonIceboxDisabled,
  FRACTURE: styles.mapButtonFractureDisabled,
  CORRODE: styles.mapButtonCorrodeDisabled,
};

interface MapNavigationProps {
  maps: MapData[];
  currentMapIndex: number;
  matchId: string;
  processedMapNames: string[];
}

const MapNavigation: React.FC<MapNavigationProps> = ({ maps, currentMapIndex, matchId, processedMapNames }) => {
  const navigate = useNavigate();

  const isMapProcessed = (mapName: string) => {
    return processedMapNames.includes(mapName);
  };

  const handleMapClick = (map: MapData, index: number) => {
    if (isMapProcessed(map.map_name)) {
      navigate(`/match/${matchId}/${index + 1}`);
    }
  };

  return (
    <div className={styles.mapNavigation}>
      {maps.map((map, index) => {
        const isActive = index + 1 === currentMapIndex;
        const isProcessed = isMapProcessed(map.map_name);
        
        return (
          <Button
            variant="outline-primary"
            className={`
              ${styles.mapButton}
              ${isProcessed ? mapColorClasses[map.map_name] || '' : mapDisabledColorClasses[map.map_name] || ''}
              ${isActive ? styles.mapButtonActive : ''}
              ${isActive && isProcessed ? mapActiveColorClasses[map.map_name] || '' : ''}
              ${!isProcessed ? styles.mapButtonDisabled : ''}
            `}
            key={index}
            onClick={() => handleMapClick(map, index)}
            disabled={!isProcessed}
          >
            {map.map_name}
          </Button>
        );
      })}
    </div>
  );
};

export default MapNavigation;
